export const enum Tasks {
  maxSpeed = '0',
  splitStream = '1',
  overtaking = '2',
  finishPosition = '3'
}
